import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import PricingStore from 'src/app_deprecated/stores/PricingStore';

import { pricingAtom } from 'src/app/state/pricing';

import { QueryBuilderMultiSelect } from './query-builder-multiselect';

type PricingTierDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type PricingTier = {
  id: number;
  name: string;
};

export function PricingTierDropdown({ onChange, values, disabled = false }: PricingTierDropdownProps) {
  const [loading, setLoading] = useState(false);
  const { lspChargeCodes: pricingTiers } = useRecoilValue(pricingAtom);
  const transformedPricingTiers: PricingTier[] = (pricingTiers || []).map((pricingTier) => ({
    id: pricingTier.ChargeCodeId,
    name: pricingTier.ChargeCodeName,
  }));

  async function handleRefresh() {
    setLoading(true);
    await PricingStore.refreshLspChargeCodes();
    setLoading(false);
  }

  return (
    <QueryBuilderMultiSelect<PricingTier>
      automationIdPrefix='pricing-tier'
      defaultLabel='Select a pricing tier'
      disabled={disabled}
      idKey='id'
      items={transformedPricingTiers}
      loading={loading}
      nameKey='name'
      refreshData={handleRefresh}
      values={values}
      onChange={onChange}
    />
  );
}
